(function () {
    // 注册组件
    SR.component.extend('askBar', askBar);
    
    function askBar() {
        if (!SR.state.isSmartRobot) {
            return;
        }
        if (SR.state.isH5) {
            // H5 渠道输入框交互
            var $body = SR.dom.$body;
            var $scrollWrap = SR.dom.$scrollWrap;
            var $askBar = SR.dom.$askBar;
            var $askBarInput = $askBar.find('.ask-bar-input');
            var $submitBtn = $askBar.find('.submit-btn');
            var $cleanBtn = $askBar.find('.J_cleanBtn');
            var loadingTag = 'asking';
            var isiPhonefullScreen = (function() {
                if (typeof window !== 'undefined' && window) {
                    return /iphone/gi.test(window.navigator.userAgent) && window.screen.height >= 812;
                }
                return false;
            })();

            $askBarInput.on('focus', function () {
                if (!isiPhonefullScreen) {
                    var setBarPosTimer = setInterval(function () {
                        $scrollWrap.scrollTop(SR.data.MAX_INTEGER);
                        SR.dom.$body.scrollTop(SR.data.MAX_INTEGER);
                    }, 100);
                    setTimeout(function () {
                        clearInterval(setBarPosTimer);
                    }, 400);
                }
                var $me = $(this);
                var content = $me.val();
                if (content.length) {
                    $cleanBtn.show();
                } else {
                    $cleanBtn.hide();
                }
            }).on('keyup', function (e) {
                if (SR.state.askMode === 'staff') {
                    return;
                }
                var $me = $(this);
                var content = $me.val();
                if (content.length) {
                    $cleanBtn.show();
                } else {
                    $cleanBtn.hide();
                }
                if(e.keyCode === 13) {
                    if ($body.hasClass(loadingTag)) {
                        return;
                    }
                    if (content.length) {
                        window.ask(content);
                        $me.val('');
                        $cleanBtn.hide();
                    }
                } else {
                    // 搜索建议
                    SR.component.autoComplete.getSuggestion(content);
                }
            }).on('blur', function() {
                SR.dom.$body.scrollLeft(10);
            });

            $cleanBtn.on('click', function (e) {
                e.preventDefault();
                $askBarInput.val('');
                $cleanBtn.hide();
                $askBarInput.trigger('change');
            });

            $submitBtn.on('click', function () {
                if ($body.hasClass(loadingTag)) {
                    return;
                }
                var content = $askBarInput.val() || $askBarInput.attr('data-presetContent');
                if (content) {
                    window.ask(content);
                    $askBarInput.val('');
                    $cleanBtn.hide();
                }
            });
        }
    }
}());